// extracted by mini-css-extract-plugin
export default {"ZoomBg":"Drag_ZoomBg__VyccE","ZoomSlider":"Drag_ZoomSlider__9DooJ"};